module.exports = __webpack_public_path__ + "assets/5fef21159120adb8c82c6bd410d5635b.mp3";